import { useCallback, useState } from "react";
import { readSvgFile } from "../../utils/svgParser";

export default function ImportPanel({ onImport }) {
  const [error, setError] = useState(null);
  const [dragActive, setDragActive] = useState(false);

  const handleFile = useCallback(
    (file) => {
      if (!file) return;
      readSvgFile(file)
        .then((parsed) => {
          setError(null);
          onImport(parsed);
        })
        .catch((err) => setError(err.message));
    },
    [onImport]
  );

  return (
    <div
      onDragOver={(e) => {
        e.preventDefault();
        setDragActive(true);
      }}
      onDragLeave={() => setDragActive(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragActive(false);
        handleFile(e.dataTransfer.files[0]);
      }}
      className={`border-2 border-dashed rounded-lg p-10 text-center transition-colors
        ${dragActive ? "border-[#2F8F6F] bg-[#0B3D2E]/30" : "border-[#145A43]"}`}
    >
      <p className="text-[#D7C7A1] mb-3">Drag & drop file SVG di sini</p>
      <label className="cursor-pointer inline-block px-4 py-2 rounded-md bg-[#145A43] text-[#D7C7A1] text-sm hover:bg-[#2F8F6F] transition-colors">
        Pilih file SVG
        <input
          type="file"
          accept=".svg,image/svg+xml"
          className="hidden"
          onChange={(e) => handleFile(e.target.files[0])}
        />
      </label>
      {error && <p className="text-red-400 text-sm mt-3">{error}</p>}
    </div>
  );
}
